/**
 * Modular PDP FAQ — client-side category filter pills (modular.faqs only).
 * Requires [data-faq-filter-root] + .modular-pdp-faq__item[data-category].
 */
(function (win, doc) {
  'use strict';

  if (win.ModularPdpFaqFilter) return;

  function initFilterRoot(root) {
    if (root.dataset.faqFilterInit === 'true') return;
    root.dataset.faqFilterInit = 'true';

    var section = root.closest('.modular-pdp-faq');
    if (!section) return;

    var list = section.querySelector('.modular-pdp-faq__list');
    if (!list) return;

    var pills = root.querySelectorAll('[data-faq-filter]');
    if (!pills.length) return;

    var items = list.querySelectorAll('.modular-pdp-faq__item[data-category]');
    if (!items.length) return;

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var filter = pill.getAttribute('data-faq-filter') || 'all';

        pills.forEach(function (p) {
          var isActive = p === pill;
          p.classList.toggle('is-active', isActive);
          p.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        items.forEach(function (item) {
          var category = item.getAttribute('data-category') || '';
          var show = filter === 'all' || category === filter;
          if (!show && item.open) {
            item.open = false;
          }
          item.hidden = !show;
        });
      });
    });
  }

  function initAll() {
    var roots = doc.querySelectorAll('[data-faq-filter-root]');
    for (var i = 0; i < roots.length; i++) {
      initFilterRoot(roots[i]);
    }
  }

  win.ModularPdpFaqFilter = { init: initAll };

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})(window, document);
